import menuicon from "../../assets/images/menu.png";
import React, { useState } from "react";
import "./header.scss";
import logo from "../../assets/images/okr-logo.png";
import { NavLink } from "react-router-dom";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuOpen = () => {
    setMenuOpen(true);
  };
  window.addEventListener("mouseup", function (event) {
    var x = document.querySelector(".menu");
    if (event.target != document.querySelector(".show-menu")) {
      setMenuOpen(false);
    }
  });

  const query = new URLSearchParams(window.location.search);
  const token = query.get("token");
  const linkData = [
    {
      value: "Objective",
      to: `/?token=${token}`,
      exact: "end",
    },
    {
      value: "Humanize Work",
      to: `/humanize-work/?token=${token}`,
    },
    {
      value: "Resilience and Analytics",
      to: `/resilience-analytics/?token=${token}`,
    },
    {
      value: "Import",
      to: `/import?token=${token}`,
    },
  ];

  return (
    <div className="header-section d-flex align-items-center justify-content-center px-3 py-2">
      <div className="d-flex align-items-center">
        <div className="logo">
          <img alt="logo" className="w-100 h-100" src={logo} />
        </div>
        <span className="ps-2 f-20 f-w-600 l-h-normal txt-black flex-1 logo-text">
          Dashboard - Collaborative OKRs
        </span>
      </div>
      <div className="ms-5"></div>
      <div className="header-menu">
        <div onClick={handleMenuOpen} className="menu-icon">
          <img src={menuicon} width="100%" height="100%" />
        </div>
        <div className={`${menuOpen ? "show" : "hide"}-menu menu`}>
          {linkData.map((navLink) => {
            return (
              <NavLink
                key={navLink.value}
                onClick={() => setMenuOpen(false)}
                className="d-block link"
                to={`${navLink.to}`}
                exact
              >
                {navLink.value}
              </NavLink>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Header;
